import {
    type BoardLayoutCache,
    boardLayoutCacheSchema,
    DEFAULT_BOARD_LAYOUT_CACHE,
} from "@components/views/board/boardLayoutCache";
import { useBoardLayoutCacheState } from "@components/views/board/useBoardLayoutCacheState";
import {
    ORGANIZATION_USER_CACHE_KEYS,
    useOrganizationUserCache,
} from "@hooks/useOrganizationUserCache";
import { useScope } from "@state/scopeContext.lib";

/**
 * The layout and collapsed columns and lanes the user keeps on the Work
 * page, per organization, shared by every view and never in the view.
 * `collapsedColumnIds` holds the columns collapsed by hand while they had
 * cards; empty columns collapse without it.
 */
export const useWorkBoardCache = () => {
    const [storedCache, setStoredCache] =
        useOrganizationUserCache<BoardLayoutCache>(
            ORGANIZATION_USER_CACHE_KEYS.CLIENTS_WORK_PAGE_BOARD_CACHE_KEY,
            boardLayoutCacheSchema,
        );
    const { activeOrganizationKey } = useScope();

    return useBoardLayoutCacheState({
        storedCache,
        setStoredCache,
        scopeKey: activeOrganizationKey,
        defaultCache: DEFAULT_BOARD_LAYOUT_CACHE,
    });
};
